export const educationData = [
    {
        id: 1,
        institution: 'kendriya vidyalaya airforce station Sulur',
        course: 'Higher Secondary Education',
        startYear: '2016',
        endYear: '2018'
    },
    {
        id: 2,
        institution: 'Central University of Harayan',
        course: 'Bachelor of Technology',
        startYear: '2018',
        endYear: 'Present'
    },
]